// extracted by mini-css-extract-plugin
export default {"readyOrders-view":"readyOrders_readyOrders-view__GUXnV","readyOrders-container":"readyOrders_readyOrders-container__wB3vw"};